import * as React from "react"

import { cn } from "../lib/utils"
import { controlBase, controlDisabled, controlFocus } from "../styles/recipes.js"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        controlBase,
        "placeholder:text-muted-foreground flex min-h-[var(--ds-textarea-min-height)] w-full px-[var(--ds-control-padding-inline)] py-[var(--ds-space-2)] text-base md:text-sm",
        controlFocus,
        controlDisabled,
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/35 aria-invalid:border-destructive",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }
